import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import DestinationCard from "@/components/DestinationCard";
import SEO from "@/components/SEO";

export default function DestinationsPage() {
  const [destinations, setDestinations] = useState([]);
  useEffect(() => { api.get("/destinations").then(({ data }) => setDestinations(data)); }, []);

  return (
    <div>
      <SEO title="US destinations" description="From Manhattan to Waikiki — curated hotel picks for the American cities travelers book most." />
      <section className="bg-cream border-b border-charcoal/5">
        <div className="container-x py-14 md:py-20">
          <div className="overline text-terracotta">Start with the city</div>
          <h1 className="mt-3 font-serif text-5xl md:text-6xl tracking-tight leading-[1.02] max-w-4xl">
            Every great American trip begins with picking where to land.
          </h1>
        </div>
      </section>
      <section className="container-x py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {destinations.map((d) => <DestinationCard key={d.key} destination={d} />)}
        </div>
      </section>
    </div>
  );
}
